import { NestedRoutes } from "../../../app/routes.types";
import { Teams } from ".";
import TeamsIcon from "../../../assets/Admin/Teams";
import { AddTeamForm } from "./AddTeam";
import { EditTeam } from "./EditTeam";
import { AddTeamMember } from "./AddTeamMember";
import { Api } from "../../../services/api";
import { UserPermissions } from "../../../enums";

export const TeamsRoutes: NestedRoutes = {
  icon: TeamsIcon,
  name: "Teams",
  path: "teams",
  component: Teams,
  permissions: [UserPermissions.TeamViewList],
  children: [
    {
      name: "Add",
      path: "add",
      component: AddTeamForm,
      permissions: [UserPermissions.TeamAddTeam],
    },
    {
      path: ":teamId",
      getName: async (params: Record<string, string>) => {
        return await Api.teams.getTeamDetails(params.teamId).then(res => {
          return res.data.nickname;
        });
      },
      children: [
        {
          name: "Edit",
          path: "edit",
          component: EditTeam,
          permissions: [
            UserPermissions.TeamViewDetails,
            UserPermissions.TeamManageDetails,
          ],
        },
        {
          name: "Add Members",
          path: "addMember",
          component: AddTeamMember,
          permissions: [UserPermissions.TeamAddMembers],
        },
      ],
    },
  ],
};
